import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("拒绝")

import {
  auditSchoolTeacherCoursewarePass,
  auditSchoolTeacherCoursewareReject,
  getSchoolTeacherCoursewareShareRecord
} from '@/services/audit-management'
import { debounce } from '@/utils/common'
import { message, Modal } from 'ant-design-vue'
import {
  ref,
  computed,
  toRaw,
  onMounted,
  createVNode
} from 'vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { TableTabMap, CoursewareTypeMap, AuditStatus } from '../../config'
import { PermissionMap } from '@/utils/auth'


export default /*#__PURE__*/_defineComponent({
  props: {
  searchBarData: {
    type: String,
    default: ''
  },
  formData: {
    type: Object
  },
  contextPage: {
    type: Number,
    default: 1
  }
},
  emits: ['onPreview', 'update:contextPage'],
  setup(__props, { expose, emit }) {

const props = __props




// 搜索框数据
const nameCompu = computed(() => props.searchBarData || '')

// 搜索表单数据
const formDataCompu = computed(() => props.formData || {})
// table数据
const tableData = ref<any[]>([])
// 加载状态
const loading = ref<boolean>(false)

// 审核弹窗可见性
const auditModalVisible = ref<boolean>(false)

// 当前审核的记录
const currentAudit = ref<any>({})

// 审核表单数据
const auditForm = ref<any>({
  result: AuditStatus.PASS,
  audit_note: undefined
})

// 审核表单
const auditFormRef = ref()

// 提交审核结果
const submitLoading = ref<boolean>(false)

// 分页信息
const pagination = ref({
  current: 1,
  total: 1,
  pageSize: 10,
  showTotal: (total: number) => `共${total}条`,
  showQuickJumper: true
})

const contPage = ref<number>(props.contextPage)

const columns = [
  {
    title: '编号',
    dataIndex: 'id',
    width: 80,
    ellipsis: true
  },
  {
    title: '课件名称',
    dataIndex: 'name',
    width: 120,
    ellipsis: true
  },
  {
    title: '课件类型',
    dataIndex: 'type',
    width: 100,
    slots: { customRender: 'type' }
  },
  {
    title: '所属教材',
    dataIndex: ['book', 'name'],
    width: 180,
    ellipsis: true
  },
  {
    title: '所属章节',
    dataIndex: 'section_breadcrumb',
    width: 180,
    ellipsis: true
  },
  {
    title: '作者',
    dataIndex: 'teacher_name',
    width: 100,
    ellipsis: true
  },
  {
    title: '提交时间',
    dataIndex: 'created_at',
    width: 180
  },
  {
    title: '操作',
    key: 'action',
    width: 150,
    slots: { customRender: 'action' }
  }
]

// 获取待审核列表
const getShareWaitAuditRecord = debounce(async (params: any) => {
  const qParams = {
    page: pagination.value.current,
    ...toRaw(formDataCompu.value),
    name: nameCompu.value || undefined,
    ...params,
    status: TableTabMap.WAIT,
    // 屏蔽掉待审核没有的审核时间参数
    audited_at_end: undefined,
    audited_at_start: undefined
  }
  try {
    loading.value = true
    const { items, meta } = await getSchoolTeacherCoursewareShareRecord(
      qParams
    )
    tableData.value = items
    pagination.value = {
      ...toRaw(pagination.value),
      ...meta,
      current: meta.current_page
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    tableData.value = []
    loading.value = false
  }
})

// 表格变化时
const handleTableChange = (page: any) => {
  pagination.value = page
  getShareWaitAuditRecord({ page: page.current })
}

// 搜索操作
const handleSearch = (changePage = true) => {
  if (changePage) { pagination.value.current = 1 }
  getShareWaitAuditRecord({})
}

// 显示审核弹窗
const handleShowAuditModal = (record: any) => {
  currentAudit.value = record
  auditModalVisible.value = true
}

// 取消审核
const handleCancelAudit = () => {
  currentAudit.value = undefined
  auditForm.value = {
    result: AuditStatus.PASS,
    audit_note: undefined
  }
  auditModalVisible.value = false
}

// 根据审核结果发送请求
const handleSubmitAudit = () => {
  const { result, audit_note } = auditForm.value
  const id = currentAudit.value.id
  submitLoading.value = true
  if (result === AuditStatus.PASS) {
    auditSchoolTeacherCoursewarePass(id, { audit_note })
      .then(() => {
        message.success('审核成功')
        submitLoading.value = false
        handleCancelAudit()
        handleSearch(false)
      })
      .catch((err: any) => {
        console.log(err)
        message.error('提交审核结果失败，请重试')
        submitLoading.value = false
      })
  } else {
    auditSchoolTeacherCoursewareReject(id, { audit_note })
      .then(() => {
        message.success('审核成功')
        submitLoading.value = false
        handleCancelAudit()
        handleSearch(false)
      })
      .catch((err: any) => {
        console.log(err)
        message.error('提交审核结果失败，请重试')
        submitLoading.value = false
      })
  }
}

// 真正提交审核的位置
const handleAccessToSubmit = () => {
  handleSubmitAudit()
  return Promise.resolve()
}

// 同意提交审核
const handleAuditOk = () => {
  auditFormRef.value.validate().then(() => {
    // 显示二次确认框
    Modal.confirm({
      title: '警告',
      icon: createVNode(ExclamationCircleOutlined),
      content: '审核结果提交后不可修改，请确认是否提交审核？',
      onOk: handleAccessToSubmit,
      onCancel: () => {
        return Promise.resolve()
      }
    })
  })
}

const handlePreview = (record: any) => {
  console.log('提交预览请求给父组件')
  emit('onPreview', record)
}

const handleGetContainer = () => {
  return document.body
}

expose({
  handleSearch,
  getCurrentPage: () => pagination.value.current
})

onMounted(() => {
  // 兼容第一期加载的时候有保存搜索数据上下文的情况
  if (contPage.value > 1) {
    pagination.value.current = contPage.value
    handleSearch(false)
    emit('update:contextPage', 1)
  } else {
    handleSearch()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_permission_in_slot = _resolveDirective("permission-in-slot")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_table, {
      dataSource: tableData.value,
      columns: columns,
      rowKey: "id",
      pagination: pagination.value,
      loading: loading.value,
      onChange: handleTableChange
    }, {
      type: _withCtx(({text}) => [
        _createElementVNode("span", null, _toDisplayString(_unref(CoursewareTypeMap)[text] || text), 1)
      ]),
      action: _withCtx(({record}) => [
        _withDirectives(_createElementVNode("a", {
          onClick: () => handleShowAuditModal(record)
        }, _hoisted_3, 8, _hoisted_1), [
          [_directive_permission_in_slot, _unref(PermissionMap).AUDIT_MANAGEMENT_SCHOOL_AUDIT]
        ]),
        _createVNode(_component_a_divider, { type: "vertical" }),
        _withDirectives(_createElementVNode("a", {
          onClick: () => handlePreview(record)
        }, _hoisted_6, 8, _hoisted_4), [
          [_directive_permission_in_slot, _unref(PermissionMap).AUDIT_MANAGEMENT_SCHOOL_PREVIEW]
        ])
      ]),
      _: 1
    }, 8, ["dataSource", "pagination", "loading"]),
    (auditModalVisible.value)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          visible: auditModalVisible.value,
          onCancel: handleCancelAudit,
          onOk: handleAuditOk,
          width: 600,
          maskClosable: false,
          getContainer: handleGetContainer
        }, {
          title: _withCtx(() => [
            _createElementVNode("span", null, [
              (currentAudit.value.name.length > 15)
                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                    key: 0,
                    title: currentAudit.value.name
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 审核课件: " + _toDisplayString(currentAudit.value.name.slice(0, 14)) + "... ", 1)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "审核课件: " + _toDisplayString(currentAudit.value.name), 1))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_spin, { spinning: submitLoading.value }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, {
                  ref: (_value, _refs) => {
                    _refs['auditFormRef'] = _value
                    auditFormRef.value = _value
                  },
                  model: auditForm.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "审核结果",
                      name: "result",
                      rules: { required: true, message: '请选择审核结果' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: auditForm.value.result,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (auditForm.value.result = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio, {
                              value: _unref(AuditStatus).PASS
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_a_radio, {
                              value: _unref(AuditStatus).FAIL
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "审核意见",
                      name: "audit_note",
                      rules: { required: auditForm.value.result === _unref(AuditStatus).FAIL, message: '请填写审核意见' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: auditForm.value.audit_note,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (auditForm.value.audit_note = $event)),
                          autosize: { minRows: 5, maxRows: 5 },
                          placeholder: "请输入审核意见"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["rules"])
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _: 1
            }, 8, ["spinning"])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})